// Scroll reveal observer
const observerOptions = { threshold: 0.1 };

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('active');
    }
  });
}, observerOptions);

document.querySelectorAll('.scroll-reveal').forEach((el) => observer.observe(el));

// Parallax effect
window.addEventListener('scroll', () => {
  const parallax = document.querySelector('.parallax-bg');
  const scrollPosition = window.pageYOffset;
  if (parallax) {
    parallax.style.transform = 'translateY(' + scrollPosition * 0.4 + 'px)';
  }
});

// Nav active state on click
document.addEventListener('DOMContentLoaded', () => {
  const navLinks = document.querySelectorAll('nav a[data-nav-link]');
  navLinks.forEach((link) => {
    link.addEventListener('click', () => {
      navLinks.forEach((l) => {
        l.classList.remove('text-primary', 'border-b-2', 'border-primary', 'pb-1');
        l.classList.add('text-on-surface', 'hover:text-primary-container');
      });
      link.classList.add('text-primary', 'border-b-2', 'border-primary', 'pb-1');
      link.classList.remove('text-on-surface', 'hover:text-primary-container');
    });
  });
});